import React, { useEffect, useState } from 'react';

interface ProgressIndicatorProps {
  current: number;
  total: number;
  stage: 'validating' | 'importing';
  estimatedTimeRemaining?: number;
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  current,
  total,
  stage,
  estimatedTimeRemaining
}) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsedTime(prev => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const percentage = Math.round((current / total) * 100);
  const estimatedTotal = estimatedTimeRemaining
    ? elapsedTime + estimatedTimeRemaining
    : null;

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  };

  return (
    <div className="w-full">
      {/* Progress Bar */}
      <div className="mb-4">
        <div className="flex justify-between items-center mb-2">
          <p className="text-sm font-medium text-gray-700">
            {stage === 'validating' ? 'Validasi' : 'Import'} Progress
          </p>
          <p className="text-sm font-bold text-blue-600">{percentage}%</p>
        </div>

        <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
          <div
            className="bg-blue-500 h-full transition-all duration-300"
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="p-3 bg-gray-50 rounded">
          <p className="text-xs text-gray-600">Waktu Berjalan</p>
          <p className="text-lg font-bold text-gray-800">{formatTime(elapsedTime)}</p>
        </div>

        {estimatedTimeRemaining !== undefined && (
          <div className="p-3 bg-gray-50 rounded">
            <p className="text-xs text-gray-600">Estimasi Sisa</p>
            <p className="text-lg font-bold text-gray-800">
              {formatTime(Math.max(0, estimatedTimeRemaining))}
            </p>
          </div>
        )}

        {estimatedTotal && (
          <div className="p-3 bg-gray-50 rounded">
            <p className="text-xs text-gray-600">Total Estimasi</p>
            <p className="text-lg font-bold text-gray-800">{formatTime(estimatedTotal)}</p>
          </div>
        )}
      </div>

      {/* Status Message */}
      <div className="text-center">
        <p className="text-sm text-gray-600">
          {stage === 'validating'
            ? 'Memvalidasi data...'
            : 'Menyimpan data ke database...'}
        </p>
      </div>
    </div>
  );
};

export default ProgressIndicator;
